<template>
    <div>
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item prop="username" label="用户名">
                    <el-input placeholder="请输入用户名" v-model="po.username" clearable></el-input>
                </el-form-item>
                <el-form-item prop="level" label="角色名称">
                    <el-select v-model="po.level" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.level" v-for="(item, i) in roleList" :key="i">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="provider" label="用户来源">
                    <el-select v-model="po.provider" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.value" v-for="(item, i) in po.providerList" :key="i">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table-opt">
                <el-button @click="addHandler">新增</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column prop="realname" label="真实姓名"> </el-table-column>
            <el-table-column prop="phone" label="手机号"> </el-table-column>
            <el-table-column prop="company_name" label="公司名"> </el-table-column>
            <el-table-column prop="username" label="用户名"> </el-table-column>
            <el-table-column prop="username" label="用户来源">
                <template #default="{ row }">
                    {{ row.provider === 'weixin' ? '微信' : '抖音' }}
                </template>
            </el-table-column>
            <el-table-column label="当前角色" min-width="130">
                <template #default="{ row }">
                    {{ roleInfo(row.level) }}
                </template>
            </el-table-column>
            <el-table-column prop="" label="会员有效期">
                <template #default="{ row }">
                    <div v-if="row.isVip">{{ row.member_start_date }} - {{ row.member_end_date }}</div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150" class-name="deal-column">
                <template #default="{ row }">
                    <el-button text type="primary" @click="editClick(row)">编辑</el-button>
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style">
            <el-pagination
                background
                layout="prev, pager, sizes, next"
                :total="vo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <FormDialog
            :visible="dialogVisible"
            @parentCallback="parentCallback"
            @closeDialog="handleCloseDialog"
            :userInfo="po.targetUserinfo"
            v-if="dialogVisible"
        />
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import FormDialog from './form/index.vue';
import { roleList } from './user.js';
const po = reactive({
    username: '',
    level: '',
    mobile: '',
    provider: '',
    pageSize: 10,
    pageNum: 1,
    providerList: [
        {
            name: '微信',
            value: 'weixin'
        },
        {
            name: '抖音',
            value: 'toutiao'
        }
    ],
    targetUserinfo: {
        id: 0,
        username: '',
        realname: '',
        level: '',
        phone: '',
        company_name: '',
        isVip: 0
    }
});
const vo = reactive({ tableList: [], loading: true, total: 0 });
const dialogVisible = ref(false);
const roleInfo = level => {
    const tempLevel = roleList.find(item => item.level === level);
    return tempLevel ? tempLevel.name : '未知';
};
const handleSizeChange = function (e) {
    po.pageSize = e;
    po.pageNum = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageNum = e;
    queryInitHandler();
};
// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    const result = await request('queryUserLists', {
        username: po.username,
        level: po.level,
        page: po.pageNum,
        perPage: po.pageSize,
        provider: po.provider
    });
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
};
queryInitHandler();

const poRef = ref(null);
const resetHandler = function () {
    poRef.value.resetFields();
    queryInitHandler();
};
const searchHandler = function () {
    po.pageNum = 1;
    queryInitHandler();
};
const openDialog = () => {
    dialogVisible.value = true;
};
const addHandler = () => {
    po.targetUserinfo = {
        id: 0,
        username: '',
        realname: '',
        level: '',
        phone: ''
    };
    openDialog();
};
const handleCloseDialog = () => {
    dialogVisible.value = false;
};
const deleteClick = row => {
    ElMessageBox.confirm('确认要删除此用户吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('updateUser', {
                id: row.id,
                status: 1
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const editClick = userinfo => {
    po.targetUserinfo = userinfo;
    openDialog();
};
const parentCallback = function () {
    handleCloseDialog();
    queryInitHandler();
};
</script>
